import { ChevronLeft, Brain } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import IdentityManager from '../../components/app/IdentityManager';
import ProductivityDNACard from '../../components/app/ProductivityDNACard';

export default function AppBrainSettings() {
    const navigate = useNavigate();

    return (
        <div className="px-4 pb-8">
            {/* Header */}
            <div className="flex items-center gap-3 mb-6">
                <button
                    onClick={() => navigate(-1)}
                    className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F5F8FA] dark:bg-dark-elevated"
                >
                    <ChevronLeft className="w-5 h-5 text-[#4A5C6A]" />
                </button>
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center">
                        <Brain className="w-4 h-4 text-white" />
                    </div>
                    <h1 className="text-xl font-bold text-[#1A2832] dark:text-white">Brain & Identity</h1>
                </div>
            </div>

            {/* Intro Text */}
            <div className="mb-6 p-4 rounded-2xl bg-gradient-to-r from-purple-50 to-indigo-50 dark:from-purple-900/20 dark:to-indigo-900/20 border border-purple-100 dark:border-purple-800/30">
                <p className="text-sm text-[#4A5C6A] dark:text-gray-300">
                    This is how your AI understands you. Edit your roles, protect important relationships, and set your North Star goal.
                    <span className="block mt-1 text-xs text-[#7B8C9B]">
                        The AI will reference this in every conversation.
                    </span>
                </p>
            </div>

            {/* Productivity DNA Card */}
            <div className="mb-4">
                <ProductivityDNACard />
            </div>

            {/* Identity Manager */}
            <IdentityManager />
        </div>
    );
}
